// Round contributions are whole percentages; questionnaire weights are separate.
export function percentageBasisPoints(value: string): number | null {
  if (!/^\d{1,3}$/.test(value)) return null;
  const bps = Number(value) * 100;
  return bps > 0 && bps <= 10000 ? bps : null;
}
